var lastId = 1;

class LayerLegend {
    /**
     * 
     * @param {*} options {
     *  title: String, 
     *  order: int, 
     *  items: [LayerLegendItem], 
     *  layer: Layer,
     *  findFeaturesForItem: function(legendItem: LayerLegendItem, vectorSource: ol.source.Vector)
     * }
     */
    constructor(options){
        this.id = lastId++;
        this.title = options.title;
        this.layer = options.layer;
        this.order = options.order;
        this.items = [...options.items];
        this.findFeaturesForItem = options.findFeaturesForItem;

        if(this.items){
            this.items.forEach(item => {
                item.legend = this;
            })    
        }
    }
}

export default LayerLegend;